import React from 'react';
import styles from './A_RadioItem.module.css';
import cn from 'classnames';

interface A_RadioItemProps {
  checked?: boolean;
  onChange?: (value: string) => void;
  label?: string;
  name?: string;
  value?: string;
  title?: string;
}

export default function A_RadioItem({
  checked = false,
  onChange,
  label,
  name,
  value,
  title,
}: A_RadioItemProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange && value) {
      onChange(value);
    }
  };

  return (
    <div className={cn(styles.wrapper)} title={title}>
      <input
        type='radio'
        checked={checked}
        onChange={handleChange}
        name={name}
        value={value}
        className={styles.radio}
      />
      {label && <label className={cn(styles.label, 'text-p-6')}>{label}</label>}
    </div>
  );
}
